import {DataTableColumns} from '../shared/data-table-columns';
import {ColumnType} from '../shared/enums';
import {
  createDenialsPaidBenchmarkColumnFor,
  createDenialsRateBenchmarkColumnFor, createDenialsVarianceColumnFor,
  createTerminalDenialsRateBenchmarkColumnFor
} from '../shared/BenchmarkColumns';
import {BenchmarkType} from '../shared/benchmark-types';

export function updateDenialsBenchmarkDepartmentColumns(column: DataTableColumns, benchmarkType: BenchmarkType): DataTableColumns {
  switch (column.columnType) {
    case ColumnType.BENCHMARK:
      return createDenialsRateBenchmarkColumnFor(benchmarkType);
    case ColumnType.DENIED_PAID_BENCHMARK:
      return createDenialsPaidBenchmarkColumnFor(benchmarkType);
    case ColumnType.TERMINAL_DENIAL_BENCHMARK:
      return createTerminalDenialsRateBenchmarkColumnFor(benchmarkType);
    case ColumnType.VARIANCE:
      return createDenialsVarianceColumnFor(benchmarkType);
    default:
      return column;
  }
}
